import { useParams } from "react-router";
import { AlertEventsWidget } from "@gf-alerting/widgets";
import { TableWrapper, Wrapper } from "./AlertHistoryTab.styles";

export default function AlertHistoryTab() {
  const { deviceId } = useParams();

  return (
    <Wrapper>
      <TableWrapper>
        <AlertEventsWidget
          type="page"
          sourceId={deviceId as string}
          cellStyles={{ height: 48, minHeight: 48 }}
        />
      </TableWrapper>
    </Wrapper>
  );
}
